import { Injectable } from '@angular/core'
import { IEmployee } from '../model/employee';
import { APIService } from '../services/api.service'
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { json } from 'ng4-validators/src/app/json/validator';
@Injectable()
export class AnalyticsService {
    employee: IEmployee;
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    }


    constructor(private _http: HttpClient, private _apiServices: APIService) { }
    // Method for get employee list
    getAppointments(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllappointmentReport", body, this.httpOptions)
            .catch(this.handleError);

    }



    gettodayAppointments(): Observable<any> {
        let loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0');
        let yyyy = today.getFullYear();
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "nowDateTime": yyyy + '-' + mm + '-' + dd
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/gettodayappointmentReport", body, this.httpOptions)
            .catch(this.handleError);

    }


    getFutureAppointments(): Observable<any> {

        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getFutureappointmentsReport", body, this.httpOptions)
            .catch(this.handleError);

    }


    searchAppointments(searchValue): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "searchValue": searchValue
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/searchAppointments", body, this.httpOptions)
            .catch(this.handleError);
    }


    getTransactions(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getTransactionDetailsReport", body, this.httpOptions)
            .catch(this.handleError);

    }
    getAllappointmentsByDate(startDate, endDate, checkedList): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "startDate": startDate,
            "endDate": endDate,
            "checkedList": checkedList,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllappointmentsByDate", body, this.httpOptions)
            .catch(this.handleError);

    }

    getActiveSubscriptionReport(startDate, endDate, checkedList): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token,
            "startDate": startDate,
            "endDate": endDate,
            "checkedList": checkedList,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/generateActiveSubscriptionReport", body, this.httpOptions)
            .catch(this.handleError);

    }

    getNewSubscriptionReport(startDate, endDate,checkedList): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token,
            "startDate": startDate,
            "endDate": endDate,
            "checkedList": checkedList,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/generateNewSubscriptionReport", body, this.httpOptions)
            .catch(this.handleError);

    }

    getPurchasedSubscriptionReport(startDate, endDate,checkedList): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token,
            "startDate": startDate,
            "endDate": endDate,
            "checkedList": checkedList,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/generatePurchasedSubscriptionPlan", body, this.httpOptions)
            .catch(this.handleError);
    }

    getSubscriptionTransactionalReport(startDate, endDate,checkedList): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "token": loginUser.token,
            "startDate": startDate,
            "endDate": endDate,
            "checkedList": checkedList,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/generateSubscriptionTransactionReport", body, this.httpOptions)
            .catch(this.handleError);
    }

    getAllPatientsByDate(startDate, endDate, checkedList): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "startDate": startDate,
            "endDate": endDate,
            "checkedList": checkedList,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllPatientsByDate", body, this.httpOptions)
            .catch(this.handleError);

    }


    searchTransactions(searchText): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "searchText": searchText
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/searchTransactions", body, this.httpOptions)
            .catch(this.handleError);

    }


    getDeshboardUsers(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getDeshboardUserReport", body, this.httpOptions)
            .catch(this.handleError);

    }

    // Added by Ramkrushna

    getDoctorsList(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getDoctors", body, this.httpOptions)
            .catch(this.handleError);

    }

    searchDoctors(searchText, usertype): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
            "searchText": searchText,
            "userType": usertype
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/filterDoctors", body, this.httpOptions)
            .catch(this.handleError);

    }

    getPatientsList(start = -1, end = -1, searchValue = ''): Observable<any> {
        debugger;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "start": start,
            "end": end,
            "searchValue": searchValue
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/AdminPatientsList", body, this.httpOptions)
            .catch(this.handleError);

    }

    getserachPatientsList(searchValue): Observable<any> {
        debugger;
        let start = -1;
        let end = -1;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "start": start,
            "end": end,
            "searchValue": searchValue
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/AdminPatientsList", body, this.httpOptions)
            .catch(this.handleError);

    }

    getStaffList(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getStaff", body, this.httpOptions)
            .catch(this.handleError);

    }

    searchPatients(searchText): Observable<any> {

        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "searchText": searchText,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/filterPatients", body, this.httpOptions)
            .catch(this.handleError);

    }


    getALLAppointmentstype(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllAppointmentTypes", body, this.httpOptions)
            .catch(this.handleError);

    }


    // Method for verify employee
    cancelAppointments(appointmentDetails, comment) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));

        let data = { "appointmentid": appointmentDetails.appointmentId, "token": loginUser.token, "comment": comment }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/cancelAppointment", body, this.httpOptions)
            .catch(this.handleError);
    }


    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts